import type { GetListResponse } from 'admin';
import type { InspectionCompany } from 'api';
import type { SelectOption } from 'form';

import { extractInspectorsFromCompanies } from '~/inspection-company';
import type { SelectedInspector } from '~/inspection-company/types';

import { sortByName } from '../sortByName/sortByName';

const sortInspectors = (insectors: SelectedInspector[]): SelectedInspector[] => {
  return insectors.sort((inspectorA, inspectorB) => sortByName(inspectorA.company.name, inspectorB.company.name));
};

const filterAllowedInspectorsByInspectionTime = (
  inspectors: SelectedInspector[],
  inspectionTime: Date
): SelectedInspector[] => {
  const isPastInspection = inspectionTime < new Date();
  return inspectors.filter((inspector) => inspector.is_active || isPastInspection);
};

const convertInspectorToSelectOption = (inspector: SelectedInspector): SelectOption => {
  return {
    label:
      `${inspector.name} (${inspector.company.name})` + (inspector.is_active ? '' : ` [INACTIVE] - ID:${inspector.id}`),
    value: inspector.id,
  };
};

export const getInspectorOptionsByInspectionTime = (
  companies: GetListResponse<InspectionCompany>,
  inspectionTime: Date
): SelectOption[] => {
  let inspectors = sortInspectors(extractInspectorsFromCompanies(companies.data));
  inspectors = filterAllowedInspectorsByInspectionTime(inspectors, inspectionTime);
  return inspectors.map(convertInspectorToSelectOption);
};
